module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "person__form__fields text-left"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('b-form-group', {
    attrs: {
      "label": ((_vm.$t('person.salutation')) + ":")
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.salutations
    },
    model: {
      value: (_vm.form.salutation),
      callback: function($$v) {
        _vm.$set(_vm.form, "salutation", $$v)
      },
      expression: "form.salutation"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('b-form-group', {
    attrs: {
      "label": ((_vm.$t('person.firstName')) + ":")
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.first_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "first_name", $$v)
      },
      expression: "form.first_name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-group', {
    attrs: {
      "label": ((_vm.$t('person.lastNamePrefix')) + ":")
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.last_name_prefix),
      callback: function($$v) {
        _vm.$set(_vm.form, "last_name_prefix", $$v)
      },
      expression: "form.last_name_prefix"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-group', {
    attrs: {
      "label": ((_vm.$t('person.lastName')) + ":")
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.last_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "last_name", $$v)
      },
      expression: "form.last_name"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-group', {
    attrs: {
      "label": ((_vm.$t('person.company')) + ":")
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.company),
      callback: function($$v) {
        _vm.$set(_vm.form, "company", $$v)
      },
      expression: "form.company"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-group', {
    attrs: {
      "label": ((_vm.$t('person.email')) + ":")
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "email",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-group', {
    attrs: {
      "label": ((_vm.$t('item.itemNumber')) + ":")
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.code),
      callback: function($$v) {
        _vm.$set(_vm.form, "code", $$v)
      },
      expression: "form.code"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-group', {
    attrs: {
      "label": ((_vm.$t('person.mobile')) + ":")
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobile", $$v)
      },
      expression: "form.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-group', {
    attrs: {
      "label": ((_vm.$t('person.telephone')) + ":")
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.telephone),
      callback: function($$v) {
        _vm.$set(_vm.form, "telephone", $$v)
      },
      expression: "form.telephone"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.mode == 'add') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    attrs: {
      "unchecked-value": false
    },
    model: {
      value: (_vm.form.no_email),
      callback: function($$v) {
        _vm.$set(_vm.form, "no_email", $$v)
      },
      expression: "form.no_email"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(("" + (_vm.$t('person.noEmail')))) + "\n\t\t\t")])], 1)]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": ((_vm.$t('person.address')) + ":")
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-group', {
    attrs: {
      "label": ((_vm.$t('person.zipcode')) + ":")
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.zipcode),
      callback: function($$v) {
        _vm.$set(_vm.form, "zipcode", $$v)
      },
      expression: "form.zipcode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-group', {
    attrs: {
      "label": ((_vm.$t('person.city')) + ":")
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.city),
      callback: function($$v) {
        _vm.$set(_vm.form, "city", $$v)
      },
      expression: "form.city"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-group', {
    attrs: {
      "label": ((_vm.$t('person.country')) + ":")
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.countryList
    },
    model: {
      value: (_vm.form.country),
      callback: function($$v) {
        _vm.$set(_vm.form, "country", $$v)
      },
      expression: "form.country"
    }
  })], 1)], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-group', {
    attrs: {
      "label": ((_vm.$t('person.iban')) + " (" + (_vm.form.country) + "):")
    }
  }, [_c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "mask": "XXXX XXXX XXXX XXXX XXXX XXXX XXXX"
    },
    model: {
      value: (_vm.form.bank_account_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "bank_account_number", $$v)
      },
      expression: "form.bank_account_number"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.form.bank_account_number) ? [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-group', {
    attrs: {
      "label": ((_vm.$t('person.accountName')) + ":")
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.bank_account_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "bank_account_name", $$v)
      },
      expression: "form.bank_account_name"
    }
  })], 1)], 1)])] : _vm._e(), _vm._v(" "), (_vm.form.country != 'NL' && _vm.form.country != '') ? [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-group', {
    attrs: {
      "label": ((_vm.$t('person.bic')) + ":")
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.bic),
      callback: function($$v) {
        _vm.$set(_vm.form, "bic", $$v)
      },
      expression: "form.bic"
    }
  })], 1)], 1)])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-checkbox', {
    attrs: {
      "unchecked-value": false
    },
    model: {
      value: (_vm.form.cash),
      callback: function($$v) {
        _vm.$set(_vm.form, "cash", $$v)
      },
      expression: "form.cash"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(("" + (_vm.$t('person.cash')))) + "\n\t\t\t")])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": ((_vm.$t('person.invoiceEmails')) + ":")
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.invoice_emails),
      callback: function($$v) {
        _vm.$set(_vm.form, "invoice_emails", $$v)
      },
      expression: "form.invoice_emails"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": ((_vm.$t('person.note')) + ":")
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": 3,
      "max-rows": 6
    },
    model: {
      value: (_vm.form.note),
      callback: function($$v) {
        _vm.$set(_vm.form, "note", $$v)
      },
      expression: "form.note"
    }
  })], 1), _vm._v(" "), (!_vm.hideAdmin) ? _c('b-form-checkbox', {
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: (_vm.form.is_admin),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_admin", $$v)
      },
      expression: "form.is_admin"
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.$t('person.userIsAdmin')) + "\n\t")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64e76ef9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Person/Form/PersonFormFields.vue
// module id = 1319
// module chunks = 1